import { ICharacter } from "@next-platform/client-common-core";

type LorebookAttachableCharacter = Pick<ICharacter, "id" | "lorebooks"> & {
  attachedLorebookId?: string;
};

export default function getCharacterAttachedLorebookId(character: LorebookAttachableCharacter, detachedCharacterIds: Set<ICharacter["id"]>) {
  if (detachedCharacterIds.has(character.id)) return undefined;
  return character.attachedLorebookId ?? character.lorebooks?.[0]?.id;
}
